import { apiInstance } from "@/api/api.js"
const api = apiInstance()

export default {
  async getScreenerTemplates ({ state, commit, dispatch }, params) {
    params = params || state.screenerFilters;
    try {
      commit('setLoading', true)
      const response = await api.get('/surveys/definitions', { params })
      commit('setScreenerTemplates', response.data.items)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async getScreenerTemplate ({ state, commit, dispatch }, id) {
    try {
      commit('setLoading', true)
      const response = await api.get(`/surveys/definitions/${id}`)
      commit('setScreenerTemplate', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, { root: true })
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async getScreenerTemplateParticipants ({ state, commit, dispatch }, params) {
    params = params || state.screenerFilters;
    try {
      commit('setLoading', true)
      const response = await api.get(`/participants/surveys`, { params })
      commit('setScreenerTemplateParticipants', response.data.items)
      commit('appStates/setBreadcrumbCurrentView', 'BHI Screener', { root: true })
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async scheduleScreenerToParticipants ({ state, commit, dispatch }, params) {
    try {
      commit('setLoading', true)
      const response = await api.post(
        '/participants/surveys', params)
      commit('appStates/setSnackbarNotification', 'Screener scheduled!', { root: true })
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  }
 
}
